export default __webpack_public_path__ + "static/media/realestatemenuicon.9051dbe1.svg";